module.exports = __webpack_public_path__ + "static/media/violet_box_24dp.0a519ce2.svg";